import React from 'react'
import { Button } from '@atd/rui-base.mui.button'
import { FormControl } from '@atd/rui-base.mui.form-control'
import { Select } from '@atd/rui-base.mui.select'
import { Tab } from '@atd/rui-base.mui.tab'
import { Tabs } from '@atd/rui-base.mui.tabs'
import ValidatedTextField from '../commonComponents/validatedTextField'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'


import UndoIcon from '@mui/icons-material/Undo'

import { areaMenuItems } from '../commonComponents/unitMenuItems'
import GeocodeSearch from './geocoder'
import ScoutFeatureMap from './scoutFeatureMapLazy'

import * as scoutActions from './scoutActions'
import { checkFieldLimits } from '../lib/ddiUnits'

function mapStateToProps(state, ownProps) {
    // Check for multipart boundaries, and boundaries with holes.
    let complexBoundary = false
    if (state.scout.boundaryGeoJson) {
        for (const feature of state.scout.boundaryGeoJson.features) {
            if ((feature.geometry.type == 'MultiPolygon') ||
            (feature.geometry.type == 'Polygon' && feature.geometry.coordinates.length > 1)
            ) {
                complexBoundary = true
                break
            }
        }
    }
    let multipleEntrances = false
    if (state.scout.entrancePoints && state.scout.entrancePoints.length > 1) {
        // check if single coordinate, or array of coordinates
        multipleEntrances = Array.isArray(state.scout.entrancePoints[0])
    }

    return {
        complexBoundary: complexBoundary,
        multipleEntrances: multipleEntrances,

        boundaryPoints: state.scout.boundaryPoints,
        boundaryGeoJson: state.scout.boundaryGeoJson,
        selectedCentroid: state.scout.selectedCentroid,
        entrancePoints: state.scout.entrancePoints,
        fieldDisplayArea: state.scout.fieldDisplayArea,
        fieldAreaDisplayUnit: state.scout.fieldAreaDisplayUnit,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(scoutActions, dispatch),
    }
}


class ScoutFeatureSelection extends React.Component {
    state = {
        mode: 'field_location',
        lastChange: [],
    }

    handleClick = (map, event) => {
        if (this.props.disabled) { return }
        if (this.state.mode === 'field_location') {
            this.setState({ lastChange: [...this.state.lastChange, this.props.selectedCentroid]})
            this.props.selectCentroid([event.lngLat.lng, event.lngLat.lat])
        }
        else if (this.state.mode === 'field_entry') {
            if (this.props.multipleEntrances) return

            // this UI only supports setting a single entrance point
            this.setState({ lastChange: [...this.state.lastChange, this.props.entrancePoints]})
            this.props.setEntrancePoints([event.lngLat.lng, event.lngLat.lat])
        }
        else if (this.state.mode === 'boundary_free') {
            if (this.props.complexBoundary) return

            // this UI only supports setting a single polygon boundary with no holes
            this.setState({ lastChange: [...this.state.lastChange, {points: this.props.boundaryPoints, geoJson: this.props.boundaryGeoJson}]})
            this.props.setBoundaryPoints([...this.props.boundaryPoints, [event.lngLat.lng, event.lngLat.lat]])
            this.props.setBoundaryGeoJson([...this.props.boundaryPoints, [event.lngLat.lng, event.lngLat.lat]])
        }
    }
    handleModeChange = (_, value) => {
        this.setState({
            mode: value,
            lastChange: [],
        })
    }
    deleteFeature = () => {
        if (this.state.mode === 'field_location') {
            this.setState({ lastChange: [...this.state.lastChange, this.props.selectedCentroid] })
            this.props.selectCentroid([])
        }
        else if (this.state.mode === 'field_entry') {
            this.setState({ lastChange: [...this.state.lastChange, this.props.entrancePoints] })
            this.props.setEntrancePoints([])
        }
        else if (this.state.mode === 'boundary_free') {
            this.setState({ lastChange: [...this.state.lastChange, {points: this.props.boundaryPoints, geoJson: this.props.boundaryGeoJson}] })
            this.props.setBoundaryPoints([])
            this.props.setBoundaryGeoJson(null)
        }
    }
    startBoundary = () => {
        this.setState({ mode: 'boundary_free' })
    }
    undo = () => {
        if (this.state.mode === 'field_location' && this.state.lastChange.length != 0) {
            this.props.selectCentroid([...this.state.lastChange[this.state.lastChange.length - 1]])
            this.setState({lastChange: this.state.lastChange.slice(0, -1)})
        }
        else if (this.state.mode === 'field_entry' && this.state.lastChange.length != 0) {
            this.props.setEntrancePoints([...this.state.lastChange[this.state.lastChange.length - 1]])
            this.setState({lastChange: this.state.lastChange.slice(0, -1)})
        }
        else if (this.state.mode === 'boundary_free' && this.state.lastChange.length != 0) {
            this.props.setBoundaryPoints([...this.state.lastChange[this.state.lastChange.length - 1].points])
            this.props.setBoundaryGeoJson(this.state.lastChange[this.state.lastChange.length - 1].geoJson)

            this.setState({lastChange: this.state.lastChange.slice(0, -1)})
        }
    }

    renderTabs = () => {
        if (this.props.disabled) return

        const { mode } = this.state
        const tabSx = {
            color: '#bdbdbd',
            backgroundColor: 'var(--secondary)',
            '&.Mui-selected': {backgroundColor: 'var(--primary)', color: '#fff'},
        }

        return (
            <React.Fragment>
                <Tabs
                    variant="fullWidth"
                    sx={{paddingTop: '15px'}}
                    name="scoutTabs"
                    value={mode}
                    onChange={this.handleModeChange}
                >
                    <Tab
                        icon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Location.svg`}/>}
                        label="Location"
                        value="field_location"
                        name="fieldLocationTab"
                        sx={tabSx}
                    />
                    <Tab
                        icon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Entry.svg`}/>}
                        label="Entry"
                        value="field_entry"
                        name="fieldEntranceTab"
                        sx={{borderLeft: 'solid 2px #FFFFFF', ...tabSx}}
                    />
                    <Tab
                        icon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Boundary.svg`}/>}
                        label="Boundary"
                        value="boundary_free"
                        name="fieldBoundaryTab"
                        sx={{borderLeft: 'solid 2px #FFFFFF', ...tabSx}}
                    />
                </Tabs>
                {mode === 'field_location' && (
                    <React.Fragment>
                        <div className="mobileButtonGroup" name="locationActions">
                            <Button variant="contained"
                                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Delete${this.props.selectedCentroid.length == 0 ? 'Disabled' : 'White'}.svg`}/>}
                                onClick={this.deleteFeature}
                                disabled={this.props.selectedCentroid.length == 0}
                                className="mobileButton"
                                name="removeLocation">Remove Location</Button>
                            <Button variant="contained"
                                startIcon={<UndoIcon />}
                                onClick={this.undo}
                                disabled={this.state.lastChange.length == 0}
                                className="mobileButton"
                                name="locationUndo">Undo</Button>
                        </div>
                        <span>Click the map to add a field location marker</span>
                    </React.Fragment>
                )}
                {mode === 'field_entry' && (
                    <React.Fragment>
                        <div className="mobileButtonGroup" name="entranceActions">
                            <Button variant="contained"
                                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Delete${this.props.entrancePoints.length == 0 ? 'Disabled' : 'White'}.svg`}/>}
                                onClick={this.deleteFeature}
                                disabled={this.props.entrancePoints.length == 0 }
                                className="mobileButton"
                                name="removeEntrance">Remove Entrance</Button>
                            <Button variant="contained"
                                startIcon={<UndoIcon />}
                                onClick={this.undo}
                                disabled={this.state.lastChange.length == 0}
                                className="mobileButton"
                                name="entranceUndo">Undo</Button>
                        </div>
                        {this.renderEntranceMessage()}
                    </React.Fragment>
                )}
                {mode === 'boundary_free' && (
                    <React.Fragment>
                        <div className="mobileButtonGroup" name="boundaryActions">
                            <Button variant="contained"
                                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Delete${this.props.boundaryPoints.length == 0 ? 'Disabled' : 'White'}.svg`}/>}
                                onClick={this.deleteFeature}
                                disabled={this.props.boundaryPoints.length == 0}
                                className="mobileButton"
                                name="removeBoundary">Clear Boundary</Button>
                            <Button variant="contained"
                                startIcon={<UndoIcon />}
                                onClick={this.undo}
                                disabled={this.state.lastChange.length == 0}
                                className="mobileButton"
                                name="boundaryUndo">Undo</Button>
                        </div>
                        {this.renderBoundaryMessage()}
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }
    renderEntranceMessage = () => {
        if (this.props.multipleEntrances) {
            return (
                <span>Editing multiple entrances not supported. Please use the system the entrances originated on to modify them.</span>
            )
        }

        return (
            <span>Click the map add a field entrance marker</span>
        )
    }
    renderBoundaryMessage = () => {
        if (this.props.complexBoundary) {
            return (
                <span>Complex boundary editing not supported. Please use the system the boundary originated on to modify this boundary.</span>
            )
        }

        return (
            <span>Click to add points to the map - points will create a freeform boundary</span>
        )
    }


    renderGeoCoder = () => {
        if (this.props.disabled) return

        return (
            <GeocodeSearch/>
        )
    }

    render() {
        return (
            <div name="scoutSection">
                <div style={{display: 'flex', alignItems: 'baseline', paddingTop: '24px'}} className="stepContent-Indented">
                    <ValidatedTextField
                        label="Field Area"
                        margin="none"
                        onChange={(event) => this.props.setFieldDisplayArea(event.target.value)}
                        value={this.props.fieldDisplayArea}
                        name="fieldDisplayArea"
                        error={!!checkFieldLimits(this.props.fieldDisplayArea, this.props.fieldAreaDisplayUnit)}
                        helperText={checkFieldLimits(this.props.fieldDisplayArea, this.props.fieldAreaDisplayUnit) || ''}
                        disabled={this.props.disabled}
                        style={{marginRight: '10px', flexGrow: 2, flexShrink: 0.5}}
                    />
                    <FormControl
                        variant="standard"
                        className="unitSelectionInline"
                        margin="none"
                        disabled={this.props.disabled}
                        error={!this.props.fieldAreaDisplayUnit}
                    >
                        <Select
                            value={this.props.fieldAreaDisplayUnit || ''}
                            onChange={(event) => this.props.setFieldAreaDisplayUnit(event.target.value)}
                            name="fieldAreaDisplayUnit"
                        >
                            {areaMenuItems}
                        </Select>
                    </FormControl>
                </div>
                {this.renderTabs()}
                {this.renderGeoCoder()}
                <ScoutFeatureMap
                    handleClick={this.handleClick}
                    interactive={!this.props.disabled}
                    style={{top: '-15px'}}
                />
                <div style={{ display: 'inline-block', height: '30px' }} />
            </div>
        )
    }
}

// be sure to connect the component to the Redux state so it can use it!
export default connect(mapStateToProps, mapDispatchToProps)(ScoutFeatureSelection)
